var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"go-back-button"},on:{"click":_vm.goToMenu}},[_c('font-awesome-icon',{attrs:{"id":"go-back-icon","icon":"arrow-left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }